import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from './FormControl/component.legacy';
import FormLabel from 'react-bootstrap/FormLabel';
import { RadioGroup, Stack } from '@chakra-ui/react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { FAIcon } from '../../fa-icon';
import { i18n } from '../../../i18n/translate';
import { kebabCase } from 'lodash';
import { Checkbox } from './Checkbox/';
import { SelectionLabel } from '../../../core/components/SelectionControl/label';

export class RadioGroupControl extends FormControl {
  static propTypes = {
    name: PropTypes.string.isRequired,
    valueList: PropTypes.array.isRequired,
    valueKey: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    dataValue: PropTypes.string,
    onChange: PropTypes.func,
    onValueChange: PropTypes.func,
    truncateSize: PropTypes.number,
    controlLabelText: PropTypes.string,
    tooltip: PropTypes.string,
    inline: PropTypes.bool,
  };

  static defaultProps = {
    dataValue: '',
    inline: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      showMoreValues: !props.truncateSize,
      value: props.dataValue,
    };
  }

  onClick = value => {
    this.setState({ value });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  toggleShowMore = () => {
    this.setState({
      showMoreValues: !this.state.showMoreValues,
    });
  };

  render() {
    const { disabled, valueList, truncateSize, valueKey, labelKey, inline, name } = this.props;
    if (!valueList) {
      return;
    }
    const { showMoreValues } = this.state;
    const truncatedValueList = showMoreValues || !truncateSize ? valueList : valueList.slice(0, truncateSize);
    return (
      <div
        role="radiogroup"
        aria-describedby={this.props['aria-describedby']}
        aria-invalid={this.props['aria-invalid']}
      >
        {this.props.controlLabelText && <FormLabel>{this.props.controlLabelText}</FormLabel>}
        {this.props.tooltip && (
          <OverlayTrigger placement="top" overlay={<Tooltip>{this.props.tooltip}</Tooltip>}>
            <span>
              <FAIcon icon="circle-question" additionalClasses="p-l-5" />
            </span>
          </OverlayTrigger>
        )}
        <RadioGroup.Root
          onValueChange={details => this.onClick(details.value)}
          name={name}
          defaultValue={String(this.state.value)}
        >
          <Stack gap={inline ? 4 : 1} direction={inline ? 'row' : 'column'}>
            {truncatedValueList.map(item => (
              <Checkbox
                data-object-action={`select-${kebabCase(item[labelKey])}`}
                isDisabled={disabled}
                key={String(item[valueKey])}
                type="radio"
                value={String(item[valueKey])}
              >
                <SelectionLabel label={item[labelKey]} />
              </Checkbox>
            ))}
            {truncateSize < valueList.length ? (
              <div className="show-more-link">
                <a onClick={this.toggleShowMore}>
                  {this.state.showMoreValues ? i18n.t('Show Less') : i18n.t('Show More')}
                </a>
              </div>
            ) : null}
          </Stack>
        </RadioGroup.Root>
      </div>
    );
  }
}
